var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirror1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 18.2426C18.7215 16.6034 20 13.9697 20 11C20 6.02944 16.4183 2 12 2C7.58172 2 4 6.02944 4 11C4 13.9697 5.27847 16.6034 7.25 18.2426V21.25H4C3.58579 21.25 3.25 21.5858 3.25 22C3.25 22.4142 3.58579 22.75 4 22.75H20C20.4142 22.75 20.75 22.4142 20.75 22C20.75 21.5858 20.4142 21.25 20 21.25H16.75V18.2426ZM15.25 19.2263V21.25H8.75V19.2263C9.74308 19.7236 10.8428 20 12 20C13.1572 20 14.2569 19.7236 15.25 19.2263Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirror1);
export default __webpack_public_path__ + "static/media/mirror-1.34f4a24dd586c7f39981f5e94f742ef0.svg";
export { ForwardRef as ReactComponent };